var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('dialog-form', { attrs: { "dialog-config": _vm.dialogConfig, "form-config": _vm.dialogFormConfig, "form-value": _vm.dialogValue, "form-item-list": _vm.dialogItemList }, on: { "submit": _vm.handleSubmit, "delete": _vm.handleDelete } });
};
var staticRenderFns = [];

export { render, staticRenderFns };